import React from 'react'

import {
    Button,
    Text,
    RadioGroup,
    Radio,
    useMultiStyleConfig,
    useStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl} from 'react-intl'
import {useHistory} from 'react-router-dom'
import PropTypes from 'prop-types'
import {Menu, MenuButton, MenuItem, MenuList} from '@chakra-ui/react'
import {ChevronDown} from '../../../components/icons'
import {noop} from '@salesforce/retail-react-app/app/utils/utils'

const SortByButton = ({
    selectedSortingOptionLabel,
    sortUrls,
    productSearchResult,
    onSelect = noop,
}) => {
    const {formatMessage} = useIntl()
    const styles = useMultiStyleConfig('Filters')
    const menuItemsStyle = useStyleConfig('SortByAccordionItem', {variant: 'sortByButton'})
    const history = useHistory()
    // const handleSortChange = (href) => {
    //     //setSortOpen(false)
    //     history.push(href)
    // }
    const [value, setValue] = React.useState(selectedSortingOptionLabel?.label)

    const handleChange = (newValue) => {
        const selectedOption = productSearchResult?.sortingOptions.find(
            (option) => option.label === newValue,
        )
        const selectedUrl = sortUrls[productSearchResult?.sortingOptions.indexOf(selectedOption)]
        setValue(newValue)
        history.push(selectedUrl)
        onSelect()
    }

    return (
        <Menu>
            {({isOpen}) => (
                <>
                    <MenuButton
                        as={Button}
                        rightIcon={
                            <ChevronDown
                                {...styles.filterIcon}
                                style={{transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'}}
                            />
                        }
                        {...styles.filterButton}
                        {...styles.refinementsSelectorButton}
                        _focusVisible={{
                            border: 'small',
                            borderColor: 'button.border.primary-focused',
                            borderStyle: 'solid',
                        }}
                    >
                        <Text {...styles.filterText}>
                            {formatMessage(
                                {id: 'product_list.button.order_by', defaultMessage: 'Order by'},
                                {sortOption: selectedSortingOptionLabel?.label},
                            )}
                        </Text>
                    </MenuButton>
                    <MenuList {...styles.sortByFilterMenuList}>
                        <RadioGroup
                            onChange={handleChange}
                            value={value}
                            {...menuItemsStyle?.menuContainer}
                        >
                            {productSearchResult?.sortingOptions?.map((option, idx) => (
                                <MenuItem
                                    key={idx}
                                    {...menuItemsStyle.menuItem}
                                    _focusVisible={{boxShadow: 'outline', bg: 'none'}}
                                    _hover={{bg: 'none'}}
                                    _focus={{bg: 'none'}}
                                >
                                    <Radio value={option.label} {...menuItemsStyle.radio}>
                                        <Text {...menuItemsStyle?.text}>{option.label}</Text>
                                    </Radio>
                                </MenuItem>
                            ))}
                        </RadioGroup>
                    </MenuList>
                </>
            )}
        </Menu>
    )
}

SortByButton.propTypes = {
    selectedSortingOptionLabel: PropTypes.shape({
        label: PropTypes.string,
    }),
    sortUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
    productSearchResult: PropTypes.shape({
        sortingOptions: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
            }),
        ),
    }),
    onSelect: PropTypes.func,
}

export default SortByButton
